import { TFunction } from 'i18next';
import { BadgePreset } from 'common/components/badge/Badge';
import { SelectValueLabel } from 'common/types/SelectValueLabel';

/**
 * Reservation status type
 */
export type ReservationStatus = 'ACTIVE' | 'PENDING_APPROVAL' | 'APPROVED' | 'REJECTED';

/**
 * Reservation status constants
 */
export const RESERVATION_STATUS = {
    ACTIVE: 'ACTIVE' as ReservationStatus,
    PENDING_APPROVAL: 'PENDING_APPROVAL' as ReservationStatus,
    APPROVED: 'APPROVED' as ReservationStatus,
    REJECTED: 'REJECTED' as ReservationStatus,
};

/**
 * Available reservation statuses (array for iterations)
 */
export const RESERVATION_STATUSES: ReservationStatus[] = [
    RESERVATION_STATUS.ACTIVE,
    RESERVATION_STATUS.PENDING_APPROVAL,
    RESERVATION_STATUS.APPROVED,
    RESERVATION_STATUS.REJECTED,
];

/**
 * Get the badge preset for a reservation status
 */
export const getReservationStatusBadgePreset = (status?: string): BadgePreset => {
    switch (status) {
        case RESERVATION_STATUS.ACTIVE:
            return 'primaryLight';
        case RESERVATION_STATUS.PENDING_APPROVAL:
            return 'warning';
        case RESERVATION_STATUS.APPROVED:
            return 'success';
        case RESERVATION_STATUS.REJECTED:
            return 'danger';
        default:
            return 'primaryLight';
    }
};

/**
 * Get the translated label for a reservation status
 */
export const getReservationStatusLabel = (status: string | undefined, t: TFunction): string => {
    switch (status) {
        case RESERVATION_STATUS.ACTIVE:
            return t('reservations.status.active') as string;
        case RESERVATION_STATUS.PENDING_APPROVAL:
            return t('reservations.status.pending') as string;
        case RESERVATION_STATUS.APPROVED:
            return t('reservations.status.approved') as string;
        case RESERVATION_STATUS.REJECTED:
            return t('reservations.status.rejected') as string;
        default:
            return status || '';
    }
};

/**
 * Get status options for select/filter components
 */
export const getReservationStatusOptions = (t: TFunction): SelectValueLabel[] => {
    return RESERVATION_STATUSES.map(status => ({
        value: status,
        label: getReservationStatusLabel(status, t),
    }));
};
